
/**
 * Aucor Starter style string localization function
 *
 * @param {string} key
 */
export const ask__ = (key) => {

  if (typeof window.ortonWebsiteData !== 'undefined' && typeof window.ortonWebsiteData.i18n.strings[key] !== 'undefined') {
    return window.ortonWebsiteData.i18n.strings[key];
  } else {
    console.error('i18n error: string not found by key: ' + key);
  }
  return key;

};
